import LogoWideAr from "../assets/logos/wideArNew.png";
import LogoWideEn from "../assets/logos/wideEnNew.png";
import { classNames } from "../helpers";
import i18n from "../i18n";

export default function AppLogo({className}:{className?: string}) {
  return (
    <img
      className={classNames("h-20 w-auto", className)}
      src={i18n.language === "ar" ? LogoWideAr : LogoWideEn}
      alt="SANAD logo"
    />
  );
}
